import { jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { components } from "react-select";
import "./styles/assets/images/icons/material/designSystem/AccessTime.js";
import "./styles/assets/images/icons/material/designSystem/AccessTimeFilled.js";
import "./styles/assets/images/icons/material/designSystem/AccountCircle.js";
import "./styles/assets/images/icons/material/designSystem/AccountCircleFilled.js";
import "./styles/assets/images/icons/material/designSystem/Add.js";
import "./styles/assets/images/icons/material/designSystem/AddCircle.js";
import "./styles/assets/images/icons/material/designSystem/AddCircleFilled.js";
import "./styles/assets/images/icons/material/designSystem/AddLocation.js";
import "./styles/assets/images/icons/material/designSystem/AddLocationFilled.js";
import "./styles/assets/images/icons/material/designSystem/AdminPanelSettings.js";
import "./styles/assets/images/icons/material/designSystem/AdminPanelSettingsFilled.js";
import "./styles/assets/images/icons/material/designSystem/Analytics.js";
import "./styles/assets/images/icons/material/designSystem/AnalyticsFilled.js";
import "./styles/assets/images/icons/material/designSystem/Apartment.js";
import "./styles/assets/images/icons/material/designSystem/Apps.js";
import "./styles/assets/images/icons/material/designSystem/ArrowBack.js";
import "./styles/assets/images/icons/material/designSystem/ArrowCircleLeft.js";
import "./styles/assets/images/icons/material/designSystem/ArrowCircleLeftFilled.js";
import "./styles/assets/images/icons/material/designSystem/ArrowCircleRight.js";
import "./styles/assets/images/icons/material/designSystem/ArrowCircleRightFilled.js";
import "./styles/assets/images/icons/material/designSystem/ArrowDownward.js";
import "./styles/assets/images/icons/material/designSystem/ArrowDropDown.js";
import "./styles/assets/images/icons/material/designSystem/ArrowDropUp.js";
import "./styles/assets/images/icons/material/designSystem/ArrowForward.js";
import "./styles/assets/images/icons/material/designSystem/ArrowUpward.js";
import "./styles/assets/images/icons/material/designSystem/Bolt.js";
import "./styles/assets/images/icons/material/designSystem/BoltFilled.js";
import "./styles/assets/images/icons/material/designSystem/BugReport.js";
import "./styles/assets/images/icons/material/designSystem/Business.js";
import "./styles/assets/images/icons/material/designSystem/Calculate.js";
import "./styles/assets/images/icons/material/designSystem/CalculateFilled.js";
import "./styles/assets/images/icons/material/designSystem/CalendarTodayFilled.js";
import "./styles/assets/images/icons/material/designSystem/Cancel.js";
import "./styles/assets/images/icons/material/designSystem/CancelFilled.js";
import "./styles/assets/images/icons/material/designSystem/CheckCircle.js";
import "./styles/assets/images/icons/material/designSystem/CheckCircleFilled.js";
import "./styles/assets/images/icons/material/designSystem/ChevronLeft.js";
import "./styles/assets/images/icons/material/designSystem/ChevronRight.js";
import "./styles/assets/images/icons/material/designSystem/Circle.js";
import "./styles/assets/images/icons/material/designSystem/CircleFilled.js";
import "./styles/assets/images/icons/material/designSystem/Close.js";
import "./styles/assets/images/icons/material/designSystem/CoPresent.js";
import "./styles/assets/images/icons/material/designSystem/CoPresentFilled.js";
import "./styles/assets/images/icons/material/designSystem/ConfirmationNumber.js";
import "./styles/assets/images/icons/material/designSystem/ConfirmationNumberFilled.js";
import "./styles/assets/images/icons/material/designSystem/ContactSupport.js";
import "./styles/assets/images/icons/material/designSystem/ContactSupportFilled.js";
import "./styles/assets/images/icons/material/designSystem/ContentCopy.js";
import "./styles/assets/images/icons/material/designSystem/CopyAll.js";
import "./styles/assets/images/icons/material/designSystem/CreditCard.js";
import "./styles/assets/images/icons/material/designSystem/CreditCardFilled.js";
import "./styles/assets/images/icons/material/designSystem/Dashboard.js";
import "./styles/assets/images/icons/material/designSystem/DashboardFilled.js";
import "./styles/assets/images/icons/material/designSystem/Delete.js";
import "./styles/assets/images/icons/material/designSystem/DeleteFilled.js";
import "./styles/assets/images/icons/material/designSystem/DirectionsCar.js";
import "./styles/assets/images/icons/material/designSystem/DirectionsCarFilled.js";
import "./styles/assets/images/icons/material/designSystem/DirectionsFilled.js";
import "./styles/assets/images/icons/material/designSystem/DisabledByDefault.js";
import "./styles/assets/images/icons/material/designSystem/DisabledByDefaultFilled.js";
import "./styles/assets/images/icons/material/designSystem/DoNotDisturb.js";
import "./styles/assets/images/icons/material/designSystem/Edit.js";
import "./styles/assets/images/icons/material/designSystem/EditFilled.js";
import "./styles/assets/images/icons/material/designSystem/ElectricCar.js";
import "./styles/assets/images/icons/material/designSystem/ElectricCarFilled.js";
import "./styles/assets/images/icons/material/designSystem/Error.js";
import "./styles/assets/images/icons/material/designSystem/ErrorFilled.js";
import "./styles/assets/images/icons/material/designSystem/EventFilled.js";
import "./styles/assets/images/icons/material/designSystem/ExpandContent.js";
import { ReactComponent as ForwardRef } from "./styles/assets/images/icons/material/designSystem/ExpandLess.js";
import { ReactComponent as ForwardRef$1 } from "./styles/assets/images/icons/material/designSystem/ExpandMore.js";
import "./styles/assets/images/icons/material/designSystem/Favorite.js";
import "./styles/assets/images/icons/material/designSystem/FavoriteFilled.js";
import "./styles/assets/images/icons/material/designSystem/FileCopy.js";
import "./styles/assets/images/icons/material/designSystem/FileCopyFilled.js";
import "./styles/assets/images/icons/material/designSystem/FilterAltFilled.js";
import "./styles/assets/images/icons/material/designSystem/FirstPage.js";
import "./styles/assets/images/icons/material/designSystem/Forward.js";
import "./styles/assets/images/icons/material/designSystem/GarageHome.js";
import "./styles/assets/images/icons/material/designSystem/GarageHomeFilled.js";
import "./styles/assets/images/icons/material/designSystem/GridView.js";
import "./styles/assets/images/icons/material/designSystem/Group.js";
import "./styles/assets/images/icons/material/designSystem/GroupFilled.js";
import "./styles/assets/images/icons/material/designSystem/Help.js";
import "./styles/assets/images/icons/material/designSystem/HelpFilled.js";
import "./styles/assets/images/icons/material/designSystem/HideSource.js";
import "./styles/assets/images/icons/material/designSystem/Home.js";
import "./styles/assets/images/icons/material/designSystem/HomeFilled.js";
import "./styles/assets/images/icons/material/designSystem/Info.js";
import "./styles/assets/images/icons/material/designSystem/InfoFilled.js";
import "./styles/assets/images/icons/material/designSystem/IosShare.js";
import "./styles/assets/images/icons/material/designSystem/KeyboardDoubleArrowDown.js";
import "./styles/assets/images/icons/material/designSystem/KeyboardDoubleArrowLeft.js";
import "./styles/assets/images/icons/material/designSystem/KeyboardDoubleArrowRight.js";
import "./styles/assets/images/icons/material/designSystem/KeyboardDoubleArrowUp.js";
import "./styles/assets/images/icons/material/designSystem/LastPage.js";
import "./styles/assets/images/icons/material/designSystem/Link.js";
import "./styles/assets/images/icons/material/designSystem/ListAlt.js";
import "./styles/assets/images/icons/material/designSystem/ListAltFilled.js";
import "./styles/assets/images/icons/material/designSystem/LocalLibraryFilled.js";
import "./styles/assets/images/icons/material/designSystem/LocationOn.js";
import "./styles/assets/images/icons/material/designSystem/LocationOnFilled.js";
import "./styles/assets/images/icons/material/designSystem/LockOpen.js";
import "./styles/assets/images/icons/material/designSystem/LockReset.js";
import "./styles/assets/images/icons/material/designSystem/Logout.js";
import "./styles/assets/images/icons/material/designSystem/Loop.js";
import "./styles/assets/images/icons/material/designSystem/Mail.js";
import "./styles/assets/images/icons/material/designSystem/MailFilled.js";
import "./styles/assets/images/icons/material/designSystem/Menu.js";
import "./styles/assets/images/icons/material/designSystem/MonitorHeart.js";
import "./styles/assets/images/icons/material/designSystem/MonitorHeartFilled.js";
import "./styles/assets/images/icons/material/designSystem/MoreHoriz.js";
import "./styles/assets/images/icons/material/designSystem/MoreVert.js";
import "./styles/assets/images/icons/material/designSystem/NetworkCheck.js";
import "./styles/assets/images/icons/material/designSystem/NotificationImportant.js";
import "./styles/assets/images/icons/material/designSystem/NotificationImportantFilled.js";
import "./styles/assets/images/icons/material/designSystem/Notifications.js";
import "./styles/assets/images/icons/material/designSystem/NotificationsActive.js";
import "./styles/assets/images/icons/material/designSystem/NotificationsActiveFilled.js";
import "./styles/assets/images/icons/material/designSystem/NotificationsFilled.js";
import "./styles/assets/images/icons/material/designSystem/NotificationsOff.js";
import "./styles/assets/images/icons/material/designSystem/NotificationsOffFilled.js";
import "./styles/assets/images/icons/material/designSystem/Paid.js";
import "./styles/assets/images/icons/material/designSystem/PaidFilled.js";
import "./styles/assets/images/icons/material/designSystem/Pending.js";
import "./styles/assets/images/icons/material/designSystem/Percent.js";
import "./styles/assets/images/icons/material/designSystem/Person.js";
import "./styles/assets/images/icons/material/designSystem/PersonAdd.js";
import "./styles/assets/images/icons/material/designSystem/PersonAddFilled.js";
import "./styles/assets/images/icons/material/designSystem/PersonFilled.js";
import "./styles/assets/images/icons/material/designSystem/PhoneDisabled.js";
import "./styles/assets/images/icons/material/designSystem/PhoneDisabledFilled.js";
import "./styles/assets/images/icons/material/designSystem/PointOfSale.js";
import "./styles/assets/images/icons/material/designSystem/PriceChange.js";
import "./styles/assets/images/icons/material/designSystem/PriceChangeFilled.js";
import "./styles/assets/images/icons/material/designSystem/PriceCheck.js";
import "./styles/assets/images/icons/material/designSystem/Publish.js";
import "./styles/assets/images/icons/material/designSystem/PublishFilled.js";
import "./styles/assets/images/icons/material/designSystem/PushPin.js";
import "./styles/assets/images/icons/material/designSystem/PushPinFilled.js";
import "./styles/assets/images/icons/material/designSystem/QuestionMark.js";
import "./styles/assets/images/icons/material/designSystem/Receipt.js";
import "./styles/assets/images/icons/material/designSystem/ReceiptFilled.js";
import "./styles/assets/images/icons/material/designSystem/Refresh.js";
import "./styles/assets/images/icons/material/designSystem/RemoveCircle.js";
import "./styles/assets/images/icons/material/designSystem/RemoveCircleFilled.js";
import "./styles/assets/images/icons/material/designSystem/Replay.js";
import "./styles/assets/images/icons/material/designSystem/Reply.js";
import "./styles/assets/images/icons/material/designSystem/Restore.js";
import "./styles/assets/images/icons/material/designSystem/Route.js";
import "./styles/assets/images/icons/material/designSystem/Save.js";
import "./styles/assets/images/icons/material/designSystem/SaveFilled.js";
import "./styles/assets/images/icons/material/designSystem/Schedule.js";
import "./styles/assets/images/icons/material/designSystem/Search.js";
import "./styles/assets/images/icons/material/designSystem/Security.js";
import "./styles/assets/images/icons/material/designSystem/Settings.js";
import "./styles/assets/images/icons/material/designSystem/SettingsFilled.js";
import "./styles/assets/images/icons/material/designSystem/Shield.js";
import "./styles/assets/images/icons/material/designSystem/ShieldFilled.js";
import "./styles/assets/images/icons/material/designSystem/Smartphone.js";
import "./styles/assets/images/icons/material/designSystem/SmartphoneFilled.js";
import "./styles/assets/images/icons/material/designSystem/Square.js";
import "./styles/assets/images/icons/material/designSystem/SquareFilled.js";
import "./styles/assets/images/icons/material/designSystem/SwapHorizontalCircle.js";
import "./styles/assets/images/icons/material/designSystem/SwapHorizontalCircleFilled.js";
import "./styles/assets/images/icons/material/designSystem/TableView.js";
import "./styles/assets/images/icons/material/designSystem/Tune.js";
import "./styles/assets/images/icons/material/designSystem/Undo.js";
import "./styles/assets/images/icons/material/designSystem/Update.js";
import "./styles/assets/images/icons/material/designSystem/Videocam.js";
import "./styles/assets/images/icons/material/designSystem/VideocamFilled.js";
import "./styles/assets/images/icons/material/designSystem/ViewList.js";
import "./styles/assets/images/icons/material/designSystem/ViewListFilled.js";
import "./styles/assets/images/icons/material/designSystem/Visibility.js";
import "./styles/assets/images/icons/material/designSystem/VisibilityFilled.js";
import "./styles/assets/images/icons/material/designSystem/VisibilityOffFilled.js";
import "./styles/assets/images/icons/material/designSystem/Warning.js";
import "./styles/assets/images/icons/material/designSystem/WarningFilled.js";
import "./styles/assets/images/icons/material/designSystem/WiFi.js";
import "./styles/assets/images/icons/material/designSystem/WiFiOff.js";
import "./styles/assets/images/icons/material/designSystem/Work.js";
import "./styles/assets/images/icons/material/designSystem/WorkFilled.js";
import "./styles/assets/images/icons/brands/GoogleG.js";
import { sass } from "./sass/sass.js";
import { invokeFnSync } from "./utils/invokeFn.js";
import { M as MapCache, b as arrayPush, o as overArg, k as keys, c as getSymbols, s as stubArray, d as baseGetAllKeys, U as Uint8Array, a as getTag, S as Stack, g as getAllKeys } from "./_Uint8Array-806c1b52.js";
import { d as defineProperty, s as setToString, o as overRest, k as keysIn } from "./keysIn-f10bd97a.js";
import { d as isArray, e as eq, j as isArguments, b as isPrototype, n as nodeUtil, k as baseUnary, f as isBuffer } from "./_arrayLikeKeys-44b287e6.js";
import { S as Symbol$1, a as isObject, i as isObjectLike, b as baseGetTag, r as root } from "./isObject-ec23ace2.js";
import { i as isSymbol } from "./isSymbol-c6f5cd95.js";
function arrayMap(array, iteratee) {
  for (var index = -1, length = array == null ? 0 : array.length, result = Array(length); ++index < length; )
    result[index] = iteratee(array[index], index, array);
  return result;
}
var INFINITY$1 = 1 / 0, symbolProto$1 = Symbol$1 ? Symbol$1.prototype : void 0, symbolToString = symbolProto$1 ? symbolProto$1.toString : void 0;
function baseToString(value) {
  if (typeof value == "string")
    return value;
  if (isArray(value))
    return arrayMap(value, baseToString) + "";
  if (isSymbol(value))
    return symbolToString ? symbolToString.call(value) : "";
  var result = value + "";
  return result == "0" && 1 / value == -INFINITY$1 ? "-0" : result;
}
var objectCreate = Object.create, baseCreate = function() {
  function object() {
  }
  return function(proto) {
    if (!isObject(proto))
      return {};
    if (objectCreate)
      return objectCreate(proto);
    object.prototype = proto;
    var result = new object();
    return object.prototype = void 0, result;
  };
}();
const baseCreate$1 = baseCreate;
function copyArray(source, array) {
  var index = -1, length = source.length;
  for (array || (array = Array(length)); ++index < length; )
    array[index] = source[index];
  return array;
}
function arrayEach(array, iteratee) {
  for (var index = -1, length = array == null ? 0 : array.length; ++index < length && iteratee(array[index], index, array) !== !1; )
    ;
  return array;
}
function baseAssignValue(object, key, value) {
  key == "__proto__" && defineProperty ? defineProperty(object, key, {
    configurable: !0,
    enumerable: !0,
    value,
    writable: !0
  }) : object[key] = value;
}
var objectProto$2 = Object.prototype, hasOwnProperty$2 = objectProto$2.hasOwnProperty;
function assignValue(object, key, value) {
  var objValue = object[key];
  (!(hasOwnProperty$2.call(object, key) && eq(objValue, value)) || value === void 0 && !(key in object)) && baseAssignValue(object, key, value);
}
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});
  for (var index = -1, length = props.length; ++index < length; ) {
    var key = props[index], newValue = customizer ? customizer(object[key], source[key], key, object, source) : void 0;
    newValue === void 0 && (newValue = source[key]), isNew ? baseAssignValue(object, key, newValue) : assignValue(object, key, newValue);
  }
  return object;
}
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
function isKey(value, object) {
  if (isArray(value))
    return !1;
  var type = typeof value;
  return type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value) ? !0 : reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
var FUNC_ERROR_TEXT = "Expected a function";
function memoize(func, resolver) {
  if (typeof func != "function" || resolver != null && typeof resolver != "function")
    throw new TypeError(FUNC_ERROR_TEXT);
  var memoized = function() {
    var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
    if (cache.has(key))
      return cache.get(key);
    var result = func.apply(this, args);
    return memoized.cache = cache.set(key, result) || cache, result;
  };
  return memoized.cache = new (memoize.Cache || MapCache)(), memoized;
}
memoize.Cache = MapCache;
var MAX_MEMOIZE_SIZE = 500;
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    return cache.size === MAX_MEMOIZE_SIZE && cache.clear(), key;
  }), cache = result.cache;
  return result;
}
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, reEscapeChar = /\\(\\)?/g, stringToPath = memoizeCapped(function(string) {
  var result = [];
  return string.charCodeAt(0) === 46 && result.push(""), string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
  }), result;
});
const stringToPath$1 = stringToPath;
function toString(value) {
  return value == null ? "" : baseToString(value);
}
function castPath(value, object) {
  return isArray(value) ? value : isKey(value, object) ? [value] : stringToPath$1(toString(value));
}
var INFINITY = 1 / 0;
function toKey(value) {
  if (typeof value == "string" || isSymbol(value))
    return value;
  var result = value + "";
  return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
function baseGet(object, path) {
  path = castPath(path, object);
  for (var index = 0, length = path.length; object != null && index < length; )
    object = object[toKey(path[index++])];
  return index && index == length ? object : void 0;
}
var spreadableSymbol = Symbol$1 ? Symbol$1.isConcatSpreadable : void 0;
function isFlattenable(value) {
  return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1, length = array.length;
  for (predicate || (predicate = isFlattenable), result || (result = []); ++index < length; ) {
    var value = array[index];
    depth > 0 && predicate(value) ? depth > 1 ? baseFlatten(value, depth - 1, predicate, isStrict, result) : arrayPush(result, value) : isStrict || (result[result.length] = value);
  }
  return result;
}
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}
function flatRest(func) {
  return setToString(overRest(func, void 0, flatten), func + "");
}
var getPrototype = overArg(Object.getPrototypeOf, Object);
const getPrototype$1 = getPrototype;
var objectTag$1 = "[object Object]", funcProto = Function.prototype, objectProto$1 = Object.prototype, funcToString = funcProto.toString, hasOwnProperty$1 = objectProto$1.hasOwnProperty, objectCtorString = funcToString.call(Object);
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag$1)
    return !1;
  var proto = getPrototype$1(value);
  if (proto === null)
    return !0;
  var Ctor = hasOwnProperty$1.call(proto, "constructor") && proto.constructor;
  return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
function baseSlice(array, start, end) {
  var index = -1, length = array.length;
  start < 0 && (start = -start > length ? 0 : length + start), end = end > length ? length : end, end < 0 && (end += length), length = start > end ? 0 : end - start >>> 0, start >>>= 0;
  for (var result = Array(length); ++index < length; )
    result[index] = array[index + start];
  return result;
}
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}
var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports, freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module, moduleExports = freeModule && freeModule.exports === freeExports, Buffer = moduleExports ? root.Buffer : void 0, allocUnsafe = Buffer ? Buffer.allocUnsafe : void 0;
function cloneBuffer(buffer, isDeep) {
  if (isDeep)
    return buffer.slice();
  var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
  return buffer.copy(result), result;
}
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}
var nativeGetSymbols = Object.getOwnPropertySymbols, getSymbolsIn = nativeGetSymbols ? function(object) {
  for (var result = []; object; )
    arrayPush(result, getSymbols(object)), object = getPrototype$1(object);
  return result;
} : stubArray;
const getSymbolsIn$1 = getSymbolsIn;
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn$1(source), object);
}
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn$1);
}
var objectProto = Object.prototype, hasOwnProperty = objectProto.hasOwnProperty;
function initCloneArray(array) {
  var length = array.length, result = new array.constructor(length);
  return length && typeof array[0] == "string" && hasOwnProperty.call(array, "index") && (result.index = array.index, result.input = array.input), result;
}
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  return new Uint8Array(result).set(new Uint8Array(arrayBuffer)), result;
}
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var reFlags = /\w*$/;
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  return result.lastIndex = regexp.lastIndex, result;
}
var symbolProto = Symbol$1 ? Symbol$1.prototype : void 0, symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var boolTag$1 = "[object Boolean]", dateTag$1 = "[object Date]", mapTag$2 = "[object Map]", numberTag$1 = "[object Number]", regexpTag$1 = "[object RegExp]", setTag$2 = "[object Set]", stringTag$1 = "[object String]", symbolTag$1 = "[object Symbol]", arrayBufferTag$1 = "[object ArrayBuffer]", dataViewTag$1 = "[object DataView]", float32Tag$1 = "[object Float32Array]", float64Tag$1 = "[object Float64Array]", int8Tag$1 = "[object Int8Array]", int16Tag$1 = "[object Int16Array]", int32Tag$1 = "[object Int32Array]", uint8Tag$1 = "[object Uint8Array]", uint8ClampedTag$1 = "[object Uint8ClampedArray]", uint16Tag$1 = "[object Uint16Array]", uint32Tag$1 = "[object Uint32Array]";
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag$1:
      return cloneArrayBuffer(object);
    case boolTag$1:
    case dateTag$1:
      return new Ctor(+object);
    case dataViewTag$1:
      return cloneDataView(object, isDeep);
    case float32Tag$1:
    case float64Tag$1:
    case int8Tag$1:
    case int16Tag$1:
    case int32Tag$1:
    case uint8Tag$1:
    case uint8ClampedTag$1:
    case uint16Tag$1:
    case uint32Tag$1:
      return cloneTypedArray(object, isDeep);
    case mapTag$2:
      return new Ctor();
    case numberTag$1:
    case stringTag$1:
      return new Ctor(object);
    case regexpTag$1:
      return cloneRegExp(object);
    case setTag$2:
      return new Ctor();
    case symbolTag$1:
      return cloneSymbol(object);
  }
}
function initCloneObject(object) {
  return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate$1(getPrototype$1(object)) : {};
}
var mapTag$1 = "[object Map]";
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag$1;
}
var nodeIsMap = nodeUtil && nodeUtil.isMap, isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
const isMap$1 = isMap;
var setTag$1 = "[object Set]";
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag$1;
}
var nodeIsSet = nodeUtil && nodeUtil.isSet, isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
const isSet$1 = isSet;
var CLONE_DEEP_FLAG$1 = 1, CLONE_FLAT_FLAG$1 = 2, CLONE_SYMBOLS_FLAG$1 = 4, argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", weakMapTag = "[object WeakMap]", arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]", cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = !0;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = !1;
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result, isDeep = bitmask & CLONE_DEEP_FLAG$1, isFlat = bitmask & CLONE_FLAT_FLAG$1, isFull = bitmask & CLONE_SYMBOLS_FLAG$1;
  if (customizer && (result = object ? customizer(value, key, object, stack) : customizer(value)), result !== void 0)
    return result;
  if (!isObject(value))
    return value;
  var isArr = isArray(value);
  if (isArr) {
    if (result = initCloneArray(value), !isDeep)
      return copyArray(value, result);
  } else {
    var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
    if (isBuffer(value))
      return cloneBuffer(value, isDeep);
    if (tag == objectTag || tag == argsTag || isFunc && !object) {
      if (result = isFlat || isFunc ? {} : initCloneObject(value), !isDeep)
        return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
    } else {
      if (!cloneableTags[tag])
        return object ? value : {};
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  stack || (stack = new Stack());
  var stacked = stack.get(value);
  if (stacked)
    return stacked;
  stack.set(value, result), isSet$1(value) ? value.forEach(function(subValue) {
    result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
  }) : isMap$1(value) && value.forEach(function(subValue, key2) {
    result.set(key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
  });
  var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys, props = isArr ? void 0 : keysFunc(value);
  return arrayEach(props || value, function(subValue, key2) {
    props && (key2 = subValue, subValue = value[key2]), assignValue(result, key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
  }), result;
}
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : void 0;
}
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}
function baseUnset(object, path) {
  return path = castPath(path, object), object = parent(object, path), object == null || delete object[toKey(last(path))];
}
function customOmitClone(value) {
  return isPlainObject(value) ? void 0 : value;
}
var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4, omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null)
    return result;
  var isDeep = !1;
  paths = arrayMap(paths, function(path) {
    return path = castPath(path, object), isDeep || (isDeep = path.length > 1), path;
  }), copyObject(object, getAllKeysIn(object), result), isDeep && (result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone));
  for (var length = paths.length; length--; )
    baseUnset(result, paths[length]);
  return result;
});
const omit$1 = omit, REACT_SELECT_FLASH_STYLE_KEYS = [
  "valueContainer",
  "indicatorsContainer",
  "dropdownIndicator",
  "option"
], REACT_SELECT_FLASH_COMPONENT_KEYS = ["IndicatorSeparator", "DropdownIndicator"];
function useReactSelectFlashStyles(custom = {}) {
  const { styles = {}, components: components$1 = {} } = custom, flashStyles = useMemo(
    () => ({
      valueContainer(base, props) {
        const custom2 = {
          ...base,
          padding: `${sass.spacing.flash[150]} 0 ${sass.spacing.flash[150]} ${sass.spacing.flash[150]}`,
          backgroundColor: props.selectProps.isDisabled ? sass.color.flash.semantic.surface.disabled : void 0
        };
        return { ...custom2, ...invokeFnSync(styles.valueContainer, [custom2, props]) };
      },
      indicatorsContainer(base, props) {
        const custom2 = {
          ...base,
          backgroundColor: props.selectProps.isDisabled ? sass.color.flash.semantic.surface.disabled : void 0,
          color: props.selectProps.isDisabled ? sass.color.flash.semantic.text.tertiary : void 0
        };
        return { ...custom2, ...invokeFnSync(styles.indicatorsContainer, [custom2, props]) };
      },
      dropdownIndicator(base, props) {
        const custom2 = {
          ...base,
          color: props.selectProps.isDisabled ? sass.color.flash.semantic.text.tertiary : void 0,
          "&:hover": {
            color: props.selectProps.isDisabled ? sass.color.flash.semantic.text.tertiary : sass.color.flash.semantic.text.interactive_hovered
          }
        };
        return { ...custom2, ...invokeFnSync(styles.dropdownIndicator, [custom2, props]) };
      },
      option(base, props) {
        const custom2 = {
          ...base,
          "&:hover": {
            backgroundColor: sass.color.flash.semantic.surface.hovered
          }
        };
        return !props.isSelected && !props.isFocused && (custom2.backgroundColor = sass.color.flash.semantic.surface.primary), props.isFocused && !props.isSelected && (custom2.backgroundColor = sass.color.flash.semantic.surface.hovered), props.isSelected && (custom2.color = sass.color.flash.semantic.text.interactive_hovered, custom2.backgroundColor = sass.color.flash.semantic.surface.selected, custom2.fontWeight = sass.typography.flash.core.font.weight.bold), { ...custom2, ...invokeFnSync(styles.option, [custom2, props]) };
      },
      ...omit$1(styles, ...REACT_SELECT_FLASH_STYLE_KEYS)
    }),
    [styles]
  ), flashComponents = useMemo(
    () => ({
      IndicatorSeparator: null,
      DropdownIndicator(props) {
        const iconProps = {
          height: sass.typography.flash.semantic.font.label.l.size,
          width: sass.typography.flash.semantic.font.label.l.size,
          role: "button"
        };
        return /* @__PURE__ */ jsx(components.DropdownIndicator, { ...props, children: props.selectProps.menuIsOpen ? /* @__PURE__ */ jsx(ForwardRef, { ...iconProps }) : /* @__PURE__ */ jsx(ForwardRef$1, { ...iconProps }) });
      },
      ...components$1
    }),
    [components$1]
  );
  return { styles: flashStyles, components: flashComponents };
}
export {
  REACT_SELECT_FLASH_STYLE_KEYS as R,
  REACT_SELECT_FLASH_COMPONENT_KEYS as a,
  omit$1 as o,
  useReactSelectFlashStyles as u
};
//# sourceMappingURL=useReactSelectFlashStyles-0a417fd5.js.map
